/* eslint-disable */
<template>
  <div class="settings">
    <AdminNavigation ref="navigation" indexProps="9"/>
    <div class="top-panel">
      <Header/>
      <div class="header-title-section">
        <div class="header-title"><h1>Marketing Popups</h1></div>
        <div class="header-sub-title"></div>
      </div>
    </div>
    <div class="panel">
      <AdminSettingsMenu indexProps="17"/>
      <div class="content">
        <div class="tool-bar row">
          <div class="col d-flex justify-content-end">
            <v-btn class="ml-2" dark @click="tapAddNew()">+ Add</v-btn>
          </div>
        </div>
        <div class="content-scroll-x">
          <el-table :data="records" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}"
                    :header-cell-style="{fontWeight: 100}">
            <el-table-column
                width="140"
                prop="Title"
                label="Title"
                show-overflow-tooltip
                fixed="left"
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                label="Message"
                prop="Message"
            >
              <template slot-scope="item">
                <span v-html="item.row.Message"></span>
              </template>
            </el-table-column>
            <el-table-column
                width="160"
                show-overflow-tooltip
                label="Updated Time"
                prop="UpdatedTime"
            >
              <template slot-scope="item">
                <span>{{ getDate(item.row.UpdatedTime) }}</span>
              </template>
            </el-table-column>
            <el-table-column
                width="160"
                show-overflow-tooltip
                label="Create Time"
                prop="CreatedTime"
            >
              <template slot-scope="item">
                <span>{{ getDate(item.row.CreatedTime) }}</span>
              </template>
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                label="IsActive"
                prop="IsActive"
                width="100"
            >
              <template slot-scope="item">
                <span>{{ item.row.IsActive ? 'YES' : 'NO' }}</span>
              </template>
            </el-table-column>
            <el-table-column
                width="250"
                label="Action"
            >
              <template slot-scope="item">
                <el-button size="small" link @click="handleClickModal(item.row)">Edit</el-button>
                <el-button v-if="!item.row.IsActive" class="ml-1" size="small" type="danger" @click="handleDelete(item.row)">Delete</el-button>
                <el-button v-if="!item.row.IsActive" class="ml-1" size="small" type="primary" @click="putActive(item.row)">Active</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="totalCount > listParam.pageSize" class="pagination">
            Page
            <div class="pagination-group">
              <div class="border-icon pagination-current dropdown">
                <div class="pagination-current-text">{{ listParam.pageNum }}</div>
                <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true"
                     aria-expanded="false"></div>
                <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                  <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item"
                       :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                    {{ item }}
                  </div>
                </div>
              </div>
            </div>
            <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount / listParam.pageSize) }}</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        top="5vh"
        :close-on-click-modal="false"
        :title="!curItem.id ? 'Create TPD Popup Message' : 'Edit TPD Popup Message'"
        :visible.sync="dialogVisible"
        width="60%">
      <el-form :model="curItem" :rules="rules" ref="curItem" label-width="100px" class="demo-curItem">
        <el-form-item label="Title" prop="Title">
          <el-input placeholder="Title" v-model="curItem.Title"></el-input>
        </el-form-item>
        <el-form-item label="Message" prop="Message">
          <Editor apiKey="5wu9mqdus3m0ugez0lnjdl6dcxezik3j0rnecxh62g4xf31p" :init="option" ref="editor"
                  v-model="curItem.Message"
                  placeholder="Message"/>
        </el-form-item>
        <el-form-item>
          <span class="dialog-footer d-flex float-right">
    <el-button @click="cancelModal">Cancel</el-button>
    <el-button type="primary" @click="onSave()">Save</el-button>
  </span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import AdminNavigation from '@/components/AdminNavigation'
import AdminSettingsMenu from '@/components/AdminSettingsMenu'
import Header from '@/components/Header'
import {debounce} from 'lodash';
import Editor from "@tinymce/tinymce-vue";

export default {
  name: 'AdminManageEmail',
  components: {
    AdminNavigation,
    AdminSettingsMenu,
    Header,
    Editor
  },
  data() {
    return {
      rules: {
        Title: [
          { required: true, message: 'Please fill title', trigger: 'blur' }
        ],
        Message: [
          { required: true, message: 'Please fill message', trigger: 'blur' }
        ],
      },
      categories: [],
      clientAlignments: [],
      states: utilities.getStates(),
      option: {
        plugins: 'link image code table',
        height: 400,
        branding: false,
        menu: false,
        browser_spellcheck: true
      },
      editingID: null,
      curValue: null,
      content: '',
      hasError: false,
      records: [],
      dialogVisible: false,
      successMessage: '',
      mode: 'create',
      totalCount: 0,
      curItem: {
        Title: "",
        Message: "",
      },
      listParam: {
        pageNum: 1,
        pageSize: 10,
        Message: null,
        Title: '',
        IsActive: null
      },
      MessageType: [{
        name: 'RH2',
        value: 0
      }, {
        name: 'Client Contact',
        value: 1
      }, {
        name: 'Specialist',
        value: 2
      }, {
        name: 'Examinee',
        value: 3
      }, {
        name: 'Custom',
        value: 4
      }],
      fieldList: utilities.getStaticTemplateParam(),
      editorOptions: {
        lineHeight: 1
      }
    }
  },
  computed: {
    validateTemplateName() {
      return this.curItem.EmailTemplateName.trim() !== ''
    },
    validateSubject() {
      return this.curItem.Subject.trim() !== ''
    },
    validateEmailBody() {
      return this.curItem.Body.trim() !== ''
    },
  },
  methods: {
    formatDate(date, format = "YYYY-MM-DD", currentFormat = "YYYY-MM-DD") {
      if (date && date.indexOf('0000-00-00') < 0) {
        return utilities.formatDate(date, format, currentFormat)
      }
      return ""
    },
    tapAddNew() {
      this.curItem = {
        Title: "",
        Message: "",
      }
      this.editingID = null
      this.dialogVisible = true
    },
    async onChangeActive(v, row) {
      await this.$store.dispatch("loading/setLoadComponent", true)
      const p = {
        IsActive: v ? 1 : 0
      }
      await utilities.putMarketingPopup(row.row.MarketPopupID, p)
      this.records[row.$index].IsActive = v ? 1 : 0
      await this.$store.dispatch("loading/setLoadComponent", false)
    },
    getDate(v) {
      return window.moment(v).format('DD/MM/YYYY HH:mm')
    },
    search: debounce(function () {
      this.selectPage(1)
    }, 800),
    async onSave() {
      this.$refs['curItem'].validate(async (valid) => {
        if (valid) {
          await this.$store.dispatch("loading/setLoadComponent", true)
          let obj = {...this.curItem}
          if(this.editingID) {
            await utilities.putTPDPopup(this.editingID, obj)
            await this.loadData()
          } else {
            obj.IsActive = true
            await utilities.postTPDPopup(obj)
            this.selectPage(1)
          }
          await this.$store.dispatch("loading/setLoadComponent", false)
          this.cancelModal()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancelModal() {
      this.$refs['curItem'].resetFields();
      this.dialogVisible = false
      this.curItem = {
        Title: "",
        Message: "",
      }
      this.editingID = null
    },
    handleClickModal(item) {
      this.curItem = {
        Title: item.Title,
        Message: item.Message,
      }
      this.editingID = item.TPDAssistPopupID
      this.dialogVisible = true
    },
    handleDelete(item) {
      this.$confirm({
        content: 'Are you sure you want to delete this message?',
        onConfirm: async () => {
          this.$store.dispatch("loading/setLoadComponent", true)
          await utilities.deleteSettingTPDPopUp(item.TPDAssistPopupID)
          this.$store.dispatch("loading/setLoadComponent", false)
          this.selectPage(1)
        }
      })
    },
    async putActive(item) {
      this.$store.dispatch("loading/setLoadComponent", true)
      await utilities.putSettingTPDPopUp(item.TPDAssistPopupID, true)
      this.selectPage(1)
      this.$store.dispatch("loading/setLoadComponent", false)
    },
    selectPage(index) {
      this.listParam.pageNum = index
      this.loadData()
    },

    async loadData() {
      let obj = {...this.listParam}
      for (let key in obj) {
        if (obj[key] === null || obj[key] === '') {
          delete obj[key];
        }
      }
      await this.$store.dispatch("loading/setLoadComponent", true)
      try {
        const {data, total} = await utilities.getSettingTPDPopUp(obj)
        this.totalCount = total
        this.records = data
        await this.$store.dispatch("loading/setLoadComponent", false)
      } catch (e) {
        this.records = []
        this.totalCount = 0
        await this.$store.dispatch("loading/setLoadComponent", false)
      }

    },
  },
  async beforeMount() {
    await this.loadData()
  },
  mounted() {
  },
}
</script>
